module.exports = __webpack_public_path__ + "static/media/search.d9347f82.svg";